export default function validateZipcode(zipCode) {
    return /^\d{5}(?:-\d{4})?$/.test(zipCode);
}
